var $578ebee0ed23659a$exports = {};
$578ebee0ed23659a$exports = {
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "placeholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435}\u{2026}`
};


export {$578ebee0ed23659a$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
